import ResetPassword from '@/views/ResetPassword';
import withAuth from '@/components/withAuth';

export default withAuth(ResetPassword);
